import { openLink } from "../../../tools/mgtv/link";

export function jumpToMoreBenefit(item, act_name) {
  openLink(
    `${window.gact.config.moreBenefitUrl}?award_id=${
      item.award_id
    }&act_name=${act_name}&source=${window.gact.source}_pindao&version=2`  // version=2的版本会使用新的领取奖品接口
  );
}

export function outOfLevel(info) {
  return window.$bus.user.level < info.growth_level || window.$bus.user.level > info.max_growth_level
}

export function outOfVipIdLimit(info) {
  if (info.vip_id_limit === 'mpp_svip') {
    // 判断用户身份是否匹配
    return window.$bus.user.is_mpp_svip !== 1;
  }
  return false;
}
